import styled, { ThemeProvider } from 'styled-components';
import theme from '../../styles/theme';

import logo from '../../assets/LPDlogo.png';

const LPDLogo = styled.img`
    width: 200px;
    height: auto;
`;

const HeaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 20px;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.large};
    font-weight: ${props => props.theme.font.weight.semiBold}
`;

const HeaderTitle = styled.h1`
    @media screen and (max-width: 600px) {
        display: none;
    }
`;


function Header() {
    return (
        <ThemeProvider theme={theme}>
            <HeaderContainer>
                <LPDLogo src={logo} alt="LPD Logo" />
                <HeaderTitle>
                    Online Police Reports
                </HeaderTitle>
            </HeaderContainer>
        </ThemeProvider>
    );
}

export default Header;